import { SurveyQuestionType } from './survey-question-type.enum';
import {SurveyMcqOption} from './survey-mcq-option.model';

/**
 * Model for Survey Template Question.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class SurveyQuestion {
    id: number;
    questionText: string;
    helpText: string;
    type: number;
    required: boolean;
    options: SurveyMcqOption[];
    questionType: SurveyQuestionType;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/survey/survey-question.model.ts